import req from './../../../fetch';
import { undocumentedResponse } from './../../../utils';
import { AllAPIResponses, CarbonError } from './../../../index';

type Payload = {
  channelName: string;
  expires?: number;
  nodeId: number;
  parentNodeId?: number;
  retryLimit?: number;
  timestamp?: string;
  value: unknown;
};
const post = async (
  payload: Payload,
  headers?: Headers
): Promise<AllAPIResponses<{}>> => {
  try {
    const resp = await req.post(
      '/api/publish/cnode',
      JSON.stringify(payload),
      headers
    );
    const clone = resp.clone();
    switch (resp.status) {
      case 200:
        return { data: (await resp.json()) as {}, response: clone };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default post;
